'use client';
import { useMagneticButton } from '@/app/utils/useMagneticButton';
import styles from './OrderSummary.module.css';
import Link from 'next/link';

export default function OrderSummary({ subtotal, shipping, tax, total }) {
  const magneticProps = useMagneticButton(0.15, 1.03);
  return (
    <div className={styles.summary}>
      <h2 className={styles.title}>Order Summary</h2>

      <div className={styles.rows}>
        <div className={styles.row}>
          <span className={styles.label}>Subtotal</span>
          <span className={styles.value}> DT{subtotal.toFixed(2)}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Shipping</span>
          <span className={styles.value}> DT{shipping.toFixed(2)}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Est. taxes</span>
          <span className={styles.value}> DT{tax.toFixed(2)}</span>
        </div>

        <div className={styles.divider}></div>

        <div className={`${styles.row} ${styles.total}`}>
          <span className={styles.label}>Total</span>
          <span className={styles.value}> DT{total.toFixed(2)}</span>
        </div>
      </div>

     <Link href={"/cart/success"}> <button className={styles.checkoutBtn} {...magneticProps}>
        Proceed to Checkout
      </button></Link>

      <p className={styles.note}>
        Our manager will contact you within 15 minutes
      </p>
    </div>
  );
}
